// frontend/src/pages/AffiliateProgram.js
import '../custom.css'
import React from 'react'
import { Container, Row, Col, Card, Button, Image } from 'react-bootstrap'
import { CheckCircleFill } from 'react-bootstrap-icons'

const heroImg =
  'https://images.pexels.com/photos/6994592/pexels-photo-6994592.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=600&w=1200'

export default function AffiliateProgram () {
  return (
    <>
      {/* Hero */}
      <section className='full-bleed py-5 bg-primary-soft text-center'>
        <Container style={{ maxWidth: 960 }}>
          <h1 className='display-5 fw-bold mb-3'>Affiliate Program</h1>
          <p className='lead mb-4'>
            Earn up to <strong>30 % recurring commission</strong> by referring
            Greatly Social to your audience.
          </p>
          <Button
            variant='primary'
            size='lg'
            href='https://partners.greatlysocial.com'
            target='_blank'
            rel='noreferrer'
          >
            Become an Affiliate
          </Button>
        </Container>
      </section>

      {/* How it works */}
      <section className='py-5'>
        <Container fluid='lg'>
          <Row className='align-items-center g-5'>
            <Col md={6}>
              <Image src={heroImg} alt='Affiliate dashboard' fluid className='shadow-card rounded-4' />
            </Col>
            <Col md={6}>
              <h2 className='fw-bold mb-4'>Simple three-step process</h2>
              {[
                'Sign up — approval within 24h',
                'Share your unique link',
                'Get paid for every paid plan — monthly, for life',
              ].map(txt => (
                <p key={txt} className='d-flex align-items-start gap-2 mb-3'>
                  <CheckCircleFill className='text-success mt-1' /> {txt}
                </p>
              ))}
            </Col>
          </Row>
        </Container>
      </section>

      {/* Payout tiers */}
      <section className='py-5 bg-light'>
        <Container fluid='lg'>
          <h2 className='fw-bold text-center mb-4'>Commission tiers</h2>
          <Row className='g-4 justify-content-center'>
            {[
              ['Starter', '0-10 referrals', '20 % recurring'],
              ['Pro',     '11-50 referrals', '25 % recurring'],
              ['Elite',   '50+ referrals',   '30 % recurring'],
            ].map(([tier, criteria, rate]) => (
              <Col md={4} key={tier}>
                <Card className='h-100 shadow-card text-center'>
                  <Card.Body>
                    <h5 className='fw-semibold mb-2'>{tier}</h5>
                    <p className='text-muted mb-4'>{criteria}</p>
                    <h3 className='fw-bold'>{rate}</h3>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </>
  )
}
